module.exports = __webpack_public_path__ + "static/media/IMG_20181117_223318.d032ddea.jpg";